/**
 * Period Selector
 *
 * Segmented pill control for selecting analytics time periods.
 */

import React from 'react';
import { motion } from 'framer-motion';
import type { AnalyticsPeriod } from '../../../types/analytics';

const PERIODS: { value: AnalyticsPeriod; label: string }[] = [
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
  { value: '90d', label: '90d' },
];

interface PeriodSelectorProps {
  value: AnalyticsPeriod;
  onChange: (period: AnalyticsPeriod) => void;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({ value, onChange }) => {
  return (
    <div className="flex bg-gray-100 rounded-xl p-1 gap-1">
      {PERIODS.map((p) => (
        <button
          key={p.value}
          onClick={() => onChange(p.value)}
          className={`relative flex-1 py-1.5 px-3 text-xs font-semibold rounded-lg transition-colors ${
            value === p.value ? 'text-white' : 'text-gray-500'
          }`}
        >
          {value === p.value && (
            <motion.div
              layoutId="periodIndicator"
              className="absolute inset-0 bg-indigo-600 rounded-lg"
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            />
          )}
          <span className="relative z-10">{p.label}</span>
        </button>
      ))}
    </div>
  );
};
